import SiHaDocumentationStatusResourceListResultModel from '../../generated/types/model/resource/SiHaDocumentationStatusResourceListResultModel';

export default class SiHaDocumentationStatusResourceListResultViewModel extends SiHaDocumentationStatusResourceListResultModel {
  protected transformToDTO() {}
  protected transformFromDTO() {}
}
